import React from 'react';
import { Box, Paper, Typography } from '@trp-individual-investor-adv-svc/ii-prosp-components';

import { PsBeaconButton } from '../../shared/BeaconRegister';
import apptReminder from '../../../assets/images/apptReminder.svg';
import LoadingSpinner from '../../../containers/LoadingSpinner';

const AppointmentTile = ({
    rescheduleAppt,
    buttonSize,
    date,
    timeframe,
    isCustomerWebView,
    isLoading,
}) => {
    return (
        <Box id="appointment-scheduled-card-content-container" sx={{ width: '100%', height: '100%' }}>
            <Paper sx={{ boxShadow: 'none', height: '100%' }} id="appointment-scheduled-card">
                <Box
                    sx={{ padding: { xs: '16px', md: '32px' } }}
                    id="appointment-scheduled-card-content-container">
                    <Box
                        sx={{ display: 'flex', paddingBottom: '16px' }}
                        id="appointment-reminder-container">
                        <Box sx={{ paddingRight: '8px' }}>
                            <img src={apptReminder} alt="calendar-icon" />
                        </Box>
                        <Typography
                            type="caption" scale={200} bold
                            sx={{ alignContent: 'center' }}
                            id="appointment-reminder-text">
                            Appointment Reminder
                        </Typography>
                    </Box>
                    <Typography
                        type="headline" loose scale={200} bold
                        sx={{ paddingBottom: '16px' }}
                        id="scheduled-date">
                        {date}
                    </Typography>
                    <Typography id="scheduled-time" type="headline" scale={200}>
                        {timeframe}
                    </Typography>
                    <Box sx={{ paddingTop: '32px' }}>
                        <PsBeaconButton
                            variant="secondary"
                            style={{ width: buttonSize }}
                            scale="jumbo"
                            disabled={isCustomerWebView}
                            onClick={rescheduleAppt}>
                            {!isLoading && 'Reschedule or Cancel Appointment'}
                            {isLoading && <LoadingSpinner scale="mini" text="Loading..." />}
                        </PsBeaconButton>
                    </Box>
                </Box>
            </Paper>
        </Box>
    );
};

export default AppointmentTile;
